import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// Material UI
import { ThemeProvider } from "@material-ui/core";

// Material UI Date Picker
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import "./index.css";
import App from "./App";
import store from "./store";
import theme from "./theme";

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Provider store={store}>
        <App />
      </Provider>
    </MuiPickersUtilsProvider>
  </ThemeProvider>,
  document.getElementById("root")
);
